import { render } from "./ErrorView.vue?vue&type=template&id=661c95c6&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=661c95c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661c95c6"]])

export default __exports__